import { useTable, useTranslation } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import Pagination from "components/pagination";
import { IEInvoiceItem } from "interfaces";
import { EInvoiceTable } from "./table";
import { EInvoiceCard } from "./card";
import { DEFAULT_PAGE_SIZE } from "utills/constants";

export const EInvoiceListTab: React.FC = () => {
  const { translate } = useTranslation();

  const { tableQuery, filters, setFilters } = useTable<IEInvoiceItem>({
    resource: "organization/einvoices",
    syncWithLocation: true,
    pagination: {
      mode: "off",
    },
    meta: {
      resource: "invoices",
      offset: true,
    },
    filters: {
      initial: [
        { field: "per_page", operator: "eq", value: DEFAULT_PAGE_SIZE },
        { field: "page", operator: "eq", value: 1 },
      ],
    },
  });

  const data = tableQuery?.data?.data ?? [];
  const paging = tableQuery?.data?.paging;
  const mappedPaging = paging
    ? {
        current_page: paging.current_page,
        total_page: paging.page_count ?? paging.total_page,
      }
    : null;

  const _handlePageChanged = (page: number) => {
    const updatedFilters = [...filters].flatMap((item) =>
      "field" in item ? item : [],
    );
    const pageIndex = updatedFilters.findIndex(
      (filter) => filter.field === "page",
    );
    if (pageIndex < 0) {
      updatedFilters.push({ field: "page", operator: "eq", value: page });
    } else {
      updatedFilters[pageIndex].value = page;
    }

    setFilters(updatedFilters);
  };

  return (
    <div>
      {!data.length && !tableQuery.isFetching && (
        <div className="text-center py-8 text-gray-500">
          {translate("einvoice-no-data")}
        </div>
      )}

      {data.length > 0 && (
        <div className="box-container">
          <div className="sm:hidden">
            <EInvoiceCard
              data={data}
              pageSize={tableQuery?.data?.pageSize ?? DEFAULT_PAGE_SIZE}
              currentPage={mappedPaging?.current_page ?? 1}
            />
          </div>
          <div className="hidden sm:block">
            <EInvoiceTable
              data={data}
              pageSize={tableQuery?.data?.pageSize ?? DEFAULT_PAGE_SIZE}
              currentPage={mappedPaging?.current_page ?? 1}
            />
          </div>
          {mappedPaging && mappedPaging.total_page > 1 && (
            <div className="mt-6">
              <Pagination
                currentPage={mappedPaging.current_page}
                totalPage={mappedPaging.total_page}
                total={{
                  totalItems: paging?.total ?? 0,
                  total: paging?.total ?? 0,
                }}
                onChange={_handlePageChanged}
              />
            </div>
          )}
        </div>
      )}
      {tableQuery.isLoading ||
      (tableQuery.isFetching && tableQuery.isPreviousData) ? (
        <FullScreenLoading />
      ) : (
        <></>
      )}
    </div>
  );
};
